import {Grid} from "@mui/material"
import { AppModal } from "@components"
import GroupedExportsModalTable from "Pages/Admin/GroupedExports/Modal/Table"
import React from "react"
import {useGroupedExportsModal} from "../@hooks"
import {groupedExportsModalId} from "../@signals"

export default function GroupedExportsModal() {
	const { data, isLoading } = useGroupedExportsModal()

	if ( !groupedExportsModalId.value) return null

	return <AppModal
		controller={() => groupedExportsModalId.value = null}
		isOpen={ !!groupedExportsModalId.value}
		icon="file-export"
		title="Export Information"
		hideActions
		containerProps={{
			maxWidth: "lg",
			p: 2,
		}}
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<GroupedExportsModalTable data={data} isLoading={isLoading}/>
			</Grid>
		</Grid>

	</AppModal>
}